import type {
  IGetNewByIdResponseBody,
  IGetNewsByIdRequestParams,
} from "~/feature/news/type";
import { api } from "~/store/api";

const API_PREFIX = "/events/aggregated";

export const newsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNewsById: builder.query<
      IGetNewByIdResponseBody,
      IGetNewsByIdRequestParams
    >({
      query: ({ id }) => ({
        url: `${API_PREFIX}/${id}/news`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetNewsByIdQuery } = newsApi;
